const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Alelo24 = function Alelo24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M17.112 4c-1.56 0-3.086.464-4.38 1.335-.09.06-.706.5-.733.522-1.024.77-1.71.903-2.652.667a7.506 7.506 0 0 1-.412-.14 5.868 5.868 0 1 0-.213 11.059c1.404-.42 2.165-.305 3.047.317.176.124.6.396.688.46A7.873 7.873 0 1 0 17.112 4Z",
      fill: "#007858",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M14.271 13.09a1.391 1.391 0 0 1-1.722.183l-.522.83a2.378 2.378 0 0 0 2.934-.312l-.69-.7Zm-.94-3.378a2.38 2.38 0 0 0-2.032 3.676l4.308-1.841a2.38 2.38 0 0 0-2.277-1.835Zm-1.428 2.525a1.398 1.398 0 0 1 2.46-1.051l-2.46 1.051Zm5.057-3.596v4.592l.797.33-.376.903-.79-.327a.87.87 0 0 1-.388-.327 1.016 1.016 0 0 1-.152-.565V8.641h.91Zm-6.937 0v4.592l.79.33-.376.903-.79-.327a.87.87 0 0 1-.376-.322 1.016 1.016 0 0 1-.153-.564V8.64h.905Z",
      fill: "#fff",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M20.88 10.828a1.397 1.397 0 0 1 .652 1.869l.882.423a2.378 2.378 0 0 0-3.745-2.788l.658.723a1.398 1.398 0 0 1 1.553-.227Z",
      fill: "#C7D540",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M19.667 13.352a1.402 1.402 0 0 1-.656-1.869l-.881-.424a2.378 2.378 0 0 0 3.74 2.789l-.659-.723a1.4 1.4 0 0 1-1.544.227Zm-11.45.067v-1.33a2.37 2.37 0 1 0-1.311 2.12l-.382-.89a1.401 1.401 0 0 1-2.08-1.23 1.39 1.39 0 0 1 1.084-1.365A1.405 1.405 0 0 1 7.25 12.09v1.319c-.006.198.047.395.152.564.095.144.23.258.388.327l.445.176.377-.903-.395-.153Z",
      fill: "#fff",
    })
  );
};
Alelo24.defaultProps = {
  width: "26",
  height: "24",
  viewBox: "0 0 26 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
var Alelo32 = function Alelo32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("rect", {
      x: ".5",
      y: ".5",
      width: "31",
      height: "23",
      rx: "3.5",
      fill: "#fff",
      stroke: "#CCC",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M20.112 4c-1.56 0-3.086.464-4.38 1.335-.09.06-.706.5-.733.522-1.024.77-1.71.903-2.652.667a7.51 7.51 0 0 1-.412-.14 5.868 5.868 0 1 0-.213 11.059c1.404-.42 2.165-.305 3.047.317.176.124.6.396.688.46A7.873 7.873 0 1 0 20.112 4Z",
      fill: "#007858",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M17.271 13.09a1.391 1.391 0 0 1-1.722.183l-.522.83a2.378 2.378 0 0 0 2.934-.312l-.69-.7Zm-.94-3.378a2.378 2.378 0 0 0-2.032 3.676l4.308-1.841a2.38 2.38 0 0 0-2.277-1.835Zm-1.428 2.525a1.398 1.398 0 0 1 2.46-1.051l-2.46 1.051Zm5.057-3.596v4.592l.797.33-.376.903-.79-.327a.87.87 0 0 1-.388-.328 1.015 1.015 0 0 1-.152-.564V8.641h.91Zm-6.937 0v4.592l.79.33-.376.903-.79-.327a.87.87 0 0 1-.376-.322 1.016 1.016 0 0 1-.153-.564V8.64h.905Z",
      fill: "#fff",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M23.88 10.828a1.398 1.398 0 0 1 .652 1.869l.881.423a2.378 2.378 0 0 0-3.745-2.788l.66.723a1.399 1.399 0 0 1 1.552-.227Z",
      fill: "#C7D540",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M22.667 13.352a1.402 1.402 0 0 1-.656-1.868l-.881-.425a2.379 2.379 0 0 0 3.74 2.789l-.659-.723a1.4 1.4 0 0 1-1.544.227Zm-11.45.067v-1.33a2.37 2.37 0 1 0-1.311 2.12l-.382-.89a1.401 1.401 0 0 1-2.08-1.23 1.39 1.39 0 0 1 1.084-1.365 1.405 1.405 0 0 1 1.722 1.365v1.319c-.006.198.047.395.152.564.095.144.23.258.388.327l.445.176.377-.903-.395-.153Z",
      fill: "#fff",
    })
  );
};
Alelo32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Alelo24,
  32: Alelo32,
};
export function Alelo(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Alelo' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
